import React from "react";
import { Typography } from "antd";

function Price(props) {
	return (
		<>
			<Typography.Title level={4}>Price</Typography.Title>
			{props.state.coverageDays === 0 && props.state.dateRange && props.state.coverage ? (
				<p style={{ textAlign: "center" }}>
					{props.state.days} Days <br />${props.state.coveragePrice} per day
					{props.state.extraCoverage ? " (x2 Extra Coverage)" : ""} <br />
					<b>${props.state.total}</b> total <br />
					{props.state.extraCoverage && (
						<span style={{ color: "#1890ff", fontSize: 12 }}>
							Includes Motor Truck Cargo Coverage — $1,000,000 limit / $2,500 deductible
						</span>
					)}
				</p>
			) : null}
			{props.state.coverageDays > 0 && props.state.coverage ? (
				<p style={{ textAlign: "center" }}>
					{props.state.coverageDays} Days <br />
					<b>${props.state.partial_payment_sw ? props.state.coverageProfit: props.state.coveragePrice}</b>
					{props.state.extraCoverage ? <span> x2 = <b>${props.state.total}</b></span> : null}
					{" "}total <br />
					{props.state.extraCoverage && (
						<span style={{ color: "#1890ff", fontSize: 12 }}>
							Includes Motor Truck Cargo Coverage — $1,000,000 limit / $2,500 deductible
						</span>
					)}
				</p>
			) : null}
		</>
	);
}

export default Price;
